import Vue from 'vue';

const success = (context, icals) => {
  context.icals = icals;
  context.smallLoading = false;
  toastr.success(context.$t('rentals.detail.platforms.ical_link_add_success'));
  context.closeModal('#rental-configure-other-platform-modal');
};


const failed = (context, error) => {
  context.showToasterError(error);
  context.smallLoading = false;
};

export default (context, data) => Vue.$http.post('/add-ical', data).then((response) => {
  if (response && response.status === 200) {
    success(context, response.data.icals);
  } else {
    failed(context, response);
  }
}).catch(((error) => {
  failed(context, error);
}));



// WEBPACK FOOTER //
// ./src/app/services/rental/addIcal.js